module.exports = __webpack_public_path__ + "static/cappuccino-44d70a864660f67658358e70946930b7.png";